import GeneratePage from '_modules/generate/views/GeneratePage.vue';
import Generates from './Root.vue';

export default {
  path: 'gerador',
  name: 'admin-generate',
  component: Generates,
  redirect: '/gerador/novo',
  children: [
    {
      path: 'novo',
      name: 'admin-generate-new',
      component: GeneratePage,
    },
  ],
};
